/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Recorder_Load_Devices_FailedInputs */

const en_audio_recorder_load_devices_failed = /** @type {(inputs: Audio_Recorder_Load_Devices_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to load audio devices: ${i?.error}`)
};

const fr_audio_recorder_load_devices_failed = /** @type {(inputs: Audio_Recorder_Load_Devices_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec du chargement des périphériques audio : ${i?.error}`)
};

const de_audio_recorder_load_devices_failed = /** @type {(inputs: Audio_Recorder_Load_Devices_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audiogeräte konnten nicht geladen werden: ${i?.error}`)
};

const it_audio_recorder_load_devices_failed = /** @type {(inputs: Audio_Recorder_Load_Devices_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile caricare i dispositivi audio: ${i?.error}`)
};

const ru_audio_recorder_load_devices_failed = /** @type {(inputs: Audio_Recorder_Load_Devices_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить аудиоустройства: ${i?.error}`)
};

const es_audio_recorder_load_devices_failed = /** @type {(inputs: Audio_Recorder_Load_Devices_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al cargar los dispositivos de audio: ${i?.error}`)
};

const zh_cn2_audio_recorder_load_devices_failed = /** @type {(inputs: Audio_Recorder_Load_Devices_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`音频设备加载失败：${i?.error}`)
};

const ja_audio_recorder_load_devices_failed = /** @type {(inputs: Audio_Recorder_Load_Devices_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`オーディオデバイスの読み込みに失敗しました: ${i?.error}`)
};

const hi_audio_recorder_load_devices_failed = /** @type {(inputs: Audio_Recorder_Load_Devices_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ऑडियो डिवाइस लोड करने में विफल: ${i?.error}`)
};

const pt_pt2_audio_recorder_load_devices_failed = /** @type {(inputs: Audio_Recorder_Load_Devices_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao carregar os dispositivos de áudio: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to load audio devices: {error}" |
*
* @param {Audio_Recorder_Load_Devices_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_load_devices_failed = /** @type {((inputs: Audio_Recorder_Load_Devices_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Load_Devices_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_load_devices_failed(inputs)
	if (locale === "de") return de_audio_recorder_load_devices_failed(inputs)
	if (locale === "it") return it_audio_recorder_load_devices_failed(inputs)
	if (locale === "ru") return ru_audio_recorder_load_devices_failed(inputs)
	if (locale === "es") return es_audio_recorder_load_devices_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_load_devices_failed(inputs)
	if (locale === "ja") return ja_audio_recorder_load_devices_failed(inputs)
	if (locale === "hi") return hi_audio_recorder_load_devices_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_load_devices_failed(inputs)
	return en_audio_recorder_load_devices_failed(inputs)
});